/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import {
  setSelectedAccountId,
  fetchAccountList,
  getUserDetails,
  getWeeklyBalanceAlert,
  getBulkBalanceAlerts,
  getBulkProjectionAlert,
  getArrangedOverdraftAlert,
  getCMAAlert,
} from '../redux/actions';
import { getBrandId } from '../infrastructure/config/selectors';
import { bindActionCreators } from 'redux';
import content from '../../src/content';
import { Loader } from 'web-ui-components/lib/organisms/modals';
import { getAccountDetails } from '../businessLogic/AccountsBL';

const isBorVM = (brandId) => ['B', 'VM'].includes(brandId);

export function withSubscription(AppComponent) {
  class GenericWrapper extends React.Component {
    constructor(props) {
      super(props);
      this.retryServices = this.retryServices.bind(this);
    }
    componentDidMount() {
      const {
        fetchAccountList,
        getUserDetails,
        getWeeklyBalanceAlert,
        getBulkBalanceAlerts,
        getBulkProjectionAlert,
        brandId,
        userInfo,
        setSelectedAccountId,
      } = this.props;
      if (userInfo.accountId) {
        setSelectedAccountId(userInfo.accountId);
      }
      fetchAccountList();
      getUserDetails();
      getWeeklyBalanceAlert();
      getBulkBalanceAlerts();
      if (isBorVM(brandId)) {
        getBulkProjectionAlert();
      }
    }

    // eslint-disable-next-line
    retryServices() {
      const {
        WBAAlert,
        bulkBalanceError,
        bulkProjectionError,
        userError,
        isAccountListError,
        fetchAccountList,
        getWeeklyBalanceAlert,
        getBulkBalanceAlerts,
        brandId,
        getBulkProjectionAlert,
        getUserDetails,
        arrangedOverdraftAlertError,
        accountDetails,
        getArrangedOverdraftAlert,
        cmaError,
        getCMAAlert,
      } = this.props;
      if (WBAAlert.isError) {
        getWeeklyBalanceAlert();
      }
      if (bulkBalanceError) {
        getBulkBalanceAlerts();
      }
      if (bulkProjectionError && isBorVM(brandId)) {
        getBulkProjectionAlert();
      }
      if (userError) {
        getUserDetails();
      }
      if (isAccountListError) {
        fetchAccountList();
      }
      if (arrangedOverdraftAlertError) {
        getArrangedOverdraftAlert(accountDetails.id);
      }
      if (cmaError) {
        getCMAAlert(accountDetails.id);
      }
    }

    getContent() {
      switch (this.props.brandId) {
        case 'CB':
        case 'YB':
          return content.CYB;
        case 'B':
        case 'DYB':
          return content.DYB;
        case 'VM':
          return content.VM;
      }
    }

    render() {
      const {
        isAccountListFetched,
        isUserDetailsFetched,
        bulkProjectionFetched,
        bulkBalanceAlertFetched,
        WBAAlertFetched,
        brandId,
      } = this.props;
      const isLoadingExceptBulkProjection =
        isAccountListFetched && isUserDetailsFetched && bulkBalanceAlertFetched && WBAAlertFetched;
      const isLoading = isBorVM(brandId)
        ? isLoadingExceptBulkProjection && bulkProjectionFetched
        : isLoadingExceptBulkProjection;
      return isLoading ? (
        <AppComponent {...this.props} content={this.getContent()} retry={this.retryServices} />
      ) : (
        <Loader isOpen={!isLoading} title="Please Wait" />
      );
    }
  }
  const mapStateToProps = ({
    config,
    accountList,
    userDetails,
    WBAAlert,
    bulkBalanceAlerts,
    bulkProjectionAlert,
    arrangedOverdraft,
    cmaAlert,
  }) => {
    return {
      userInfo: config.get('userInfo'),
      bankId: config.getIn(['configInfo']).bankId,
      accountList: accountList.get('accountList'),
      isAccountListFetched: accountList.get('isFetched'),
      userDetails: userDetails.get('userDetails'),
      WBAAlert: WBAAlert.get('WBAAlert'),
      brandId: getBrandId(config),
      bulkBalanceError: bulkBalanceAlerts.get('balanceError'),
      bulkProjectionError: bulkProjectionAlert.get('projectionError'),
      userError: userDetails.get('isError'),
      isUserDetailsFetched: userDetails.get('isFetched'),
      bulkProjectionFetched: bulkProjectionAlert.get('isFetched'),
      bulkBalanceAlertFetched: bulkBalanceAlerts.get('isFetched'),
      WBAAlertFetched: WBAAlert.get('isFetched'),
      isAccountListError: accountList.get('isAccountListError'),
      arrangedOverdraftAlertError: arrangedOverdraft.get('arrangedOverdraftAlertError'),
      accountDetails: getAccountDetails(
        accountList.get('selectedAccountId'),
        accountList.get('accountList').accounts
      ),
      cmaError: cmaAlert.get('cmaError'),
    };
  };
  const mapDispatch = (dispatch) =>
    bindActionCreators(
      {
        fetchAccountList,
        getUserDetails,
        getWeeklyBalanceAlert,
        getBulkBalanceAlerts,
        getBulkProjectionAlert,
        setSelectedAccountId,
        getArrangedOverdraftAlert,
        getCMAAlert,
      },
      dispatch
    );

  return connect(mapStateToProps, mapDispatch)(GenericWrapper);
}
/* eslint-enable react/prop-types */
